import { AuthenticatedRoute } from 'components/AuthenticatedRoute/AuthenticatedRoute'
import { LaunchDarklyDependentContent } from 'components/LaunchDarklyDependentContent/LaunchDarklyDependentContent'
import { Error404 } from 'Error404'
import { FC } from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'

import { PremiumsBills } from './pages/PremiumsBills/PremiumsBills'
import { PremiumsMonthly } from './pages/MonthlyPremiums/PremiumsMonthly'
import { PremiumsDashboardPage } from './pages/PremiumsDashboardPage'
import { PremiumsHistory } from './pages/PremiumsHistory/PremiumsHistory'
import { EasyPayEditPage } from './pages/EasyPay/EasyPayEditPage'
import { EasyPayEditSubmittedPage } from './pages/EasyPay/EasyPayEditSubmittedPage'
import { EasyPaySignupPage } from './pages/EasyPay/EasyPaySignupPage'
import { EasyPaySignupSubmitted } from './pages/EasyPay/EasyPaySignupSubmitted'
import { EasyPayStopPage } from './pages/EasyPay/EasyPayStopPage'
import { EasyPayStopSuccessPage } from './pages/EasyPay/EasyPayStopSuccessPage'
import { MakeAPaymentPage } from './pages/MakeAPayment/MakeAPaymentPage'
import { MakeAPaymentSuccessPage } from './pages/MakeAPayment/MakeAPaymentSuccessPage'
import { MakeAPaymentSubmittedPage } from './pages/MakeAPayment/MakeAPaymentSubmittedPage'
import { MakeAPaymentErrorPage } from './pages/MakeAPayment/MakeAPaymentErrorPage'
import { EasyPaySummaryPage } from './pages/EasyPay/EasyPaySummaryPage'
import { EasyPayErrorPage } from './pages/EasyPay/EasyPayErrorPage'
import { MakeAPaymentProcessingPage } from './pages/MakeAPayment/MakeAPaymentProcessingPage'

export const PremiumsSwitch: FC = () => {
  const match = useRouteMatch()
  const matchedPath = match.path

  const routes = {
    premiumBills: `${matchedPath}/bills`,
    premiumMonthly: `${matchedPath}/monthly`,
    premiumsDashboardRedirect: `${matchedPath}`,
    premiumsDashboard: `${matchedPath}/dashboard`,
    premiumsHistory: `${matchedPath}/history`,
    easyPay: `${matchedPath}/easy-pay`,
    easyPaySignupPage: `${matchedPath}/easy-pay/signup`,
    easyPaySignupSubmitted: `${matchedPath}/easy-pay/signup/submitted`,
    easyPayEditPage: `${matchedPath}/easy-pay/edit`,
    easyPayEditSubmittedPage: `${matchedPath}/easy-pay/edit/submitted`,
    easyPayStopPage: `${matchedPath}/easy-pay/stop`,
    easyPayStopSuccessPage: `${matchedPath}/easy-pay/stop/success`,
    easyPayErrorPage: `${matchedPath}/easy-pay/error`,
    makeAPaymentProcessingPage: `${matchedPath}/make-a-payment/processing`,
    makeAPaymentErrorPage: `${matchedPath}/make-a-payment/error`,
    makeAPaymentSuccessPage: `${matchedPath}/make-a-payment/success`,
    makeAPaymentSubmittedPage: `${matchedPath}/make-a-payment/submitted`,
    makeAPaymentPage: `${matchedPath}/make-a-payment`
  }

  return (
    <Switch>
      <AuthenticatedRoute
        path={routes.premiumBills}
        redirectPath={routes.premiumBills}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsMonthly"
          fallbackContent={<Error404 />}
        >
          <PremiumsBills />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.premiumMonthly}
        redirectPath={routes.premiumMonthly}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsMonthly"
          fallbackContent={<Error404 />}
        >
          <PremiumsMonthly />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.premiumsDashboardRedirect}
        redirectPath={routes.premiumsDashboard}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <Redirect to={routes.premiumsDashboard} />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.premiumsDashboard}
        redirectPath={routes.premiumsDashboard}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <PremiumsDashboardPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.premiumsHistory}
        redirectPath={routes.premiumsHistory}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <PremiumsHistory />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPay}
        redirectPath={routes.easyPay}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPaySummaryPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPaySignupSubmitted}
        redirectPath={routes.easyPaySignupSubmitted}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPaySignupSubmitted />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPaySignupPage}
        redirectPath={routes.easyPaySignupPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPaySignupPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPayEditSubmittedPage}
        redirectPath={routes.easyPayEditSubmittedPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPayEditSubmittedPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPayEditPage}
        redirectPath={routes.easyPayEditPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPayEditPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPayStopSuccessPage}
        redirectPath={routes.easyPayStopSuccessPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPayStopSuccessPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPayStopPage}
        redirectPath={routes.easyPayStopPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPayStopPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.easyPayErrorPage}
        redirectPath={routes.easyPayErrorPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsEasyPay"
          fallbackContent={<Error404 />}
        >
          <EasyPayErrorPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>

      <AuthenticatedRoute
        path={routes.makeAPaymentProcessingPage}
        redirectPath={routes.makeAPaymentProcessingPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <MakeAPaymentProcessingPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.makeAPaymentErrorPage}
        redirectPath={routes.makeAPaymentErrorPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <MakeAPaymentErrorPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.makeAPaymentSuccessPage}
        redirectPath={routes.makeAPaymentSuccessPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <MakeAPaymentSuccessPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.makeAPaymentSubmittedPage}
        redirectPath={routes.makeAPaymentSubmittedPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <MakeAPaymentSubmittedPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.makeAPaymentPage}
        redirectPath={routes.makeAPaymentPage}
        exact
      >
        <LaunchDarklyDependentContent
          flagName="useNewPremiumsPay"
          fallbackContent={<Error404 />}
        >
          <MakeAPaymentPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <Route>
        <Error404 />
      </Route>
    </Switch>
  )
}
